import PersonsList from './entities/persons-list';
import PersonDetails from './entities/person-details';
import PersonPrograms from './entities/person-programs';
import PersonCategory from './entities/person-category';
import PersonLifeStages from './entities/person-life-stages';
import PersonMeasurement from './entities/person-measurement';
import PersonMeasurements from './entities/person-measurements';
import PersonOccupiedDates from './entities/person-occupied-dates';
import PersonAssignProgram from './entities/person-assign-program';
import PersonCreateProgram from './entities/person-create-program';
import PersonSettingsMeasurementsGeneral from './entities/person-settings-measurements-general';
import PersonSettingsTrackedMeasurements from './entities/person-settings-tracked-measurements';
// import PersonSemanticKeyWordOperationsSelected from './entities/person-semantic-key-word-operations-selected';

export default {
  modules: {
    PersonsList,
    PersonDetails,
    PersonPrograms,
    PersonCategory,
    PersonLifeStages,
    PersonMeasurement,
    PersonMeasurements,
    PersonOccupiedDates,
    PersonAssignProgram,
    PersonCreateProgram,
    PersonSettingsMeasurementsGeneral,
    PersonSettingsTrackedMeasurements,
    // PersonSemanticKeyWordOperationsSelected,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/persons/index.js